<mat-toolbar class="p-0 mat-elevation-z1">
  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="end center">
    @if (user.isAdmin()) {
    <lin-toolbar-search></lin-toolbar-search>
    }

    <div class="shortcuts-icons-wrapper" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
      @if (sosService.alerts$ | async; as sosAlerts) { @if (sosAlerts.length) {
      <button type="button" class="sos-button" [linSosTriggerFor]="sosList" [attr.aria-label]="'SOS.LABEL' | translate">
        <mat-icon svgIcon="warning" class="sos-button-icon"></mat-icon>
        <span class="sos-button-label">{{ 'SOS.LABEL' | translate }}</span>
        <span class="sos-button-badge">{{ sosAlerts.length }}</span>
      </button>
      <lin-sos-list #sosList></lin-sos-list>
      } }
      <lin-network-status></lin-network-status>
      <!-- <lin-intercom *ngIf="isSupport"></lin-intercom> -->
      @if (!user.isAdmin() && isMessenger) {
      <lin-chat-toolbar [isNotificationSound]="isNotificationSound"></lin-chat-toolbar>
      } @if (isNotificationsPermission) {
      <!-- <mat-icon
          svgIcon="notifications"
          class="nav-link-icon"
          [matBadge]="unreadNotificationsCount || ''"
          matBadgeSize="medium"
          matBadgeColor="warn"
          [linNotificationTriggerFor]="notificationList"
        ></mat-icon>

        <lin-notification-list
          (markRead)="markNotificationRead($event)"
          (markAllRead)="markAllNotificationsRead()"
          (notificationArrived)="onNotificationsArrived($event)"
          [isNotificationPopup]="isNotificationPopup"
          [isNotificationSound]="isNotificationSound"
          #notificationList
        ></lin-notification-list> -->

      <mat-icon
        svgIcon="notifications"
        class="nav-link-icon"
        aria-hidden="false"
        [matBadge]="unreadNotificationsCount || ''"
        matBadgeSize="medium"
        matBadgeColor="warn"
        [linNotificationTriggerFor]="notificationList"
        (click)="loadNotificationList()"
      ></mat-icon>

      <lin-notification-list
        (markRead)="markNotificationRead($event)"
        (markAllRead)="markAllNotificationsRead()"
        (notificationArrived)="onNotificationsArrived($event)"
        [isNotificationPopup]="isNotificationPopup"
        [isNotificationSound]="isNotificationSound"
        #notificationList
      ></lin-notification-list>
      }
    </div>

    <div fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
      <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
        <div fxLayout="row" fxLayoutAlign="center center">
          <img class="avatar" alt="avatar" [src]="user?.picture || 'assets/images/default_avatar.png'" />
        </div>
      </button>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item routerLink="/user/profile">
          <mat-icon svgIcon="account_circle"></mat-icon>
          <span>{{ 'TOOLBAR.USERMENU.PROFILE_SETTINGS' | translate }}</span>
        </button>
        <!-- <button mat-menu-item>
          <mat-icon svgIcon="message"></mat-icon>
          <span>{{ 'TOOLBAR.USERMENU.MESSAGES' | translate }}</span>
        </button> -->
        @if (isNotifications) {
        <button mat-menu-item [routerLink]="notificationUrl">
          <mat-icon svgIcon="notifications"></mat-icon>
          <span>{{ 'TOOLBAR.USERMENU.NOTIFICATIONS' | translate }}</span>
        </button>
        }
        <button mat-menu-item [routerLink]="getSupportUrl">
          <mat-icon svgIcon="help_center"></mat-icon>
          <span>{{ 'TOOLBAR.USERMENU.HELP' | translate }} / {{ 'TOOLBAR.USERMENU.SUPPORT' | translate }}</span>
        </button>
        @if (isConfigurations) {
        <button mat-menu-item class="hide-desktop" [routerLink]="configurationUrl">
          <mat-icon svgIcon="settings"></mat-icon>
          <span>{{ 'TOOLBAR.USERMENU.CONFIGURATION' | translate }}</span>
        </button>
        }
        <button mat-menu-item (click)="logout()">
          <mat-icon svgIcon="exit_to_app"></mat-icon>
          <span>{{ 'TOOLBAR.USERMENU.LOGOUT' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>
